import React from 'react';
import Navbar from '../Components/Navbar';
import Hero from '../Components/Hero';
import HomeAboutUs from '../Components/HomeAboutUs';
import HomeProducts from '../Components/HomeProducts';
import WhyChooseUs from '../Components/WhyChooseUs';
import AdditionalProduct from '../Components/AdditionalPrduct';
import HomeBlog from '../Components/HomeBlog';
import Footer from '../Components/Footer';

function Home() {
  return (
    <>
      <Navbar />
      {/* ✅ Static Marquee Tag for Online Payment Notice */}
      <marquee behavior="scroll" direction="left" style={{ color: "red", fontSize: "16px", fontWeight: "bold", marginBottom: "10px" }}>
        🚨 All prices displayed are for lots. If you want to buy a single product, you can contact us or purchase through eBay. We are now accepting real online payments via Razorpay. However, for orders through LC, you will need to provide an Irrevocable LC at Sight from a 1st-class International Bank and send it to orders@irfanelectricals.com. 🚨
      </marquee>

      <Hero />
      <HomeAboutUs />
      <HomeProducts />
      <WhyChooseUs />
      <AdditionalProduct />
      <HomeBlog />
      <Footer />

    </>
  );
}

export default Home;
